(ns dre.components.search-results.events
  (:require
   [clojure.set :refer [difference union]]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.app.router :as router :refer [->route]]
   [dre.components.search-results.db :as db]
   [dre.network :as-alias network]
   [dre.pages.search.events :as search-events]
   [dre.pages.my-searches.signals.events :as signal-events]
   [dre.pages.my-searches.tags.events :as tag-events]
   [dre.page-util :refer [query-params]]
   [dre.utils.query :as query]
   [dre.utils :refer [stringify-keys-with-namespaces roles-hash aborted-request?]]
   [dre.shared.interface.search.pills :as pills]
   [dre.shared.interface.search.util :refer [normalized-blunt]]
   [dre.widgets.question-answering.events :as qa-events]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))


(def db-path :search)

(def db-path-boost-query :boost-query)

(def default-params
  {:limit db/default-limit
   :offset db/default-offset
   :order db/default-order})

(def allowed-params
  [:limit :offset :order :query])

;; -- Events

(rf/reg-event-fx
  ::init
  [(rf/path db-path)]
  (fn-traced
   [{db :db} [_ init-params]]
   {:db (-> (merge db default-params (into {} (remove (comp nil? second) init-params)))
            (dissoc :selected)
            (dissoc :total))}))


(rf/reg-event-fx
  ::fetch
  [rf/trim-v]
  (fn-traced
    [{db :db} [params last-seen]]
    (let [search-db (get db search-events/db-path)
          search-query (:search-query search-db)
          blunt (normalized-blunt search-query)
          blunt->signal (when (not-empty blunt) (get-in db (cons signal-events/db-path signal-events/blunt->signal-path)))
          signal (get blunt->signal blunt)
          signal (if (and signal last-seen)
                   (assoc signal :signal/new-articles 0)
                   signal)
          widget-filters (:widget-filters search-db)
          ;; ai summarization articles boosting logic
          qa-db (get-in db qa-events/db-path)
          active-ai-uris (qa-events/active-articles (get qa-db :data) :article/uri)
          ai-sum? (= (:query/order search-query) "ai-sum")
          ;;end
          aq (partial search-events/analysis-query search-query widget-filters)
          aq* (comp second aq)
          pills-api-params (aq* [])
          search-results-db (get db db-path)
          params (merge
                  (select-keys search-results-db allowed-params)
                  {:query (:query/pill pills-api-params)}
                  (select-keys params allowed-params))
          last-seen-article (and signal (or last-seen (:signal/last-seen-article signal)))
          params (if last-seen-article
                   (assoc params :last-seen-article last-seen-article)
                   params)
          params-updated (if ai-sum?
                           (assoc params :order :scoretitle-desc)
                           params)
          ;;add BAQ params from URI
          params-updated (if (and (:query/baq search-query)
                                  (let [baq-diff (- (js/Date.) (.parse js/Date (:starttime (:query/baq search-query))))]
                                    (<
                                     baq-diff
                                     (* 1000 60 60 5))))
                           (assoc params-updated :search-metadata {:query/baq (:query/baq search-query)})
                           params-updated)
          ;;boosting logic
          boosting-pills (-> (get db db-path-boost-query) :search-query :query/pills)
          boosting-pill (query/some-pills-query {:query/pills boosting-pills})
          ;;saved search logic 
          saved-search? (some? signal)]
      {:db (assoc db db-path (merge search-results-db params {:state :loading :articles [] :articles-utags nil :signal signal :clicked-article nil}))
       :fx (cond-> [[::network/request-with-abort (cond
                                                    ai-sum?
                                                    [{:endpoint :search/articles}
                                                     {:body (stringify-keys-with-namespaces
                                                             (assoc params-updated :query
                                                                    {:pill/type :or
                                                                     :pill/pills [{:pill/type :and
                                                                                   :pill/pills (:pill/pills (:query params-updated))}
                                                                                  {:pill/type :and
                                                                                   :pill/pills [{:pill/type :and
                                                                                                 :pill/pills (:pill/pills (:query params-updated))}
                                                                                                (pills/ai-sum-uris-pill active-ai-uris)]}]}))
                                                      :on-success [::fetch-ok]
                                                      :on-failure [::fetch-nok]}]
                                                    boosting-pill
                                                    [{:endpoint :search/articles}
                                                     {:body (stringify-keys-with-namespaces
                                                             (assoc params-updated :query
                                                                    {:pill/type "boost"
                                                                     :pill/pills [(assoc (:query params-updated) :pill/pills (concat [pills/lbracket]
                                                                                                                                     (:pill/pills (:query params-updated))
                                                                                                                                     [pills/rbracket]))
                                                                                  (assoc boosting-pill :pill/pills (concat [pills/lbracket]
                                                                                                                           (:pill/pills boosting-pill)
                                                                                                                           [pills/rbracket]))]}))
                                                      :on-success [::fetch-ok]
                                                      :on-failure [::fetch-nok]}]
                                                    :else
                                                    [{:endpoint :search/articles}
                                                     {:body (stringify-keys-with-namespaces params-updated)
                                                      :on-success [::fetch-ok]
                                                      :on-failure [::fetch-nok]}])]]
             saved-search?
             (concat [[:dispatch [::signal-events/mark-viewed signal]]]))})))

(rf/reg-event-fx
  ::fetch-ok
  [(rf/path db-path) rf/trim-v]
  (fn-traced
   [{db :db} [{::fetch-fx/keys [response]}]]
   {:db
    (merge db
           {:state :success}
           (:body response))
    :dispatch [::good-utags {:articles (:articles (:body response))}]}))


(rf/reg-event-fx
 ::fetch-nok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{::fetch-fx/keys [response] :as opts}]]
  (if (not (aborted-request? response))
    {:db (assoc db :state :failure)
     :dispatch [::network/default-failure (merge {:event :search} opts)]}
    {})))

(rf/reg-event-fx
 ::good-utags
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [articles ::fetch-fx/response]}]]
  (let [articles (or articles (-> (:body response) :queries first :articles))] 
   {:db (update-in db [:articles-utags]
                  (fn [utags]
                    (reduce (fn [acc {:keys [:source :uri :utags :tags]}]
                              (assoc acc [source uri] (or tags utags)))
                            utags
                            articles)))})))

(rf/reg-event-db
  ::toggle-expanded
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [{:keys [expanded articles] :as db} [guid]]
    (let [articles-ids (set (map :guid articles))
          expanded-ids (set expanded)]
      (case guid
        :all (if (empty? (difference articles-ids expanded-ids))
               (update db :expanded difference articles-ids)
               (update db :expanded union articles-ids))
        (if (contains? expanded-ids guid)
          (update db :expanded difference #{guid})
          (update db :expanded union #{guid}))))))


(rf/reg-event-db
  ::toggle-selected
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [{:keys [selected articles] :as db} [guid]]
    (let [articles-ids (set (map :guid articles))
          selected-ids (set selected)]
      (case guid
        :all (if (empty? (difference articles-ids selected-ids))
               (update db :selected difference articles-ids)
               (update db :selected union articles-ids))
        (if (contains? selected-ids guid)
          (update db :selected difference #{guid})
          (update db :selected union #{guid}))))))

(rf/reg-event-db
 ::clear-selected
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db _]
  (let []
    (assoc db :selected #{}))))


(rf/reg-event-db
  ::highlight
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [db [article]]
    (assoc db :highlight (select-keys article [:guid :group]))))

#_(rf/reg-event-db
 ::optimistic-tag-article
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db [{:keys [:source :uri :tag_uuid :action :tag]}]]
  (let [assign (= "assign" action)
        selected (get-in db [:articles-utags [source uri]])
        new-tag tag
        new-selected (if assign (conj selected new-tag)
                         (remove (fn [tag]
                                   (= tag_uuid (str (:tag_uuid tag))))
                                 selected))]
    (assoc-in db [:articles-utags [source uri]] new-selected))))

(rf/reg-event-fx
 ::fetch-articles-tags
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [external-articles]]
  (let [articles (concat external-articles (:articles db))]
    {::network/request [{:endpoint :saved/action-tags}
                        {:body {:queries [{:query "tags-for-articles"
                                           :articles articles}]}
                         :on-success [::good-utags]
                         :on-failure [::failure-fetch-articles-tags]}]})))

(rf/reg-event-fx
 ::failure-fetch-articles-tags
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{::fetch-fx/keys [response] :as opts}]]
  {:dispatch [::network/default-failure (merge {:event :article-tags} opts)]}))


(rf/reg-event-fx
 ::tag-articles
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [actions external-articles]]
  {:dispatch [::tag-events/tag-articles actions [::fetch-articles-tags external-articles]]}))

(rf/reg-event-fx
 ::replace-in-url
 [rf/trim-v]
 (fn-traced
  [{db :db} [order user]]
  (let [search-db (get db search-events/db-path)
        qp (query-params (:route search-db))
        qp (assoc qp :order (name order))]
    {:dispatch [::router/redirect-to-handler-with-query-params :search qp]})))

(rf/reg-event-db
 ::swap-show-boost-searchbar?
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{:keys [show-boost-searchbar?] :as db} _]
  (assoc db :show-boost-searchbar? (not show-boost-searchbar?))))

;; details page related

(rf/reg-event-fx
 ::set-clicked-article
 [rf/trim-v]
 (fn-traced
  [{db :db} [idx detail-event]]
  (let [search-db (get db search-events/db-path)
        search-query (:search-query search-db)
        blunt (normalized-blunt search-query)
        blunt->signal (when (not-empty blunt) (get-in db (cons signal-events/db-path signal-events/blunt->signal-path)))
        signal (get blunt->signal blunt)
        widget-filters (:widget-filters search-db)
        aq (partial search-events/analysis-query search-query widget-filters)
        aq* (comp second aq)
        pills-api-params (aq* [])
        search-results-db (get db db-path)
        params (merge
                (select-keys search-results-db allowed-params)
                {:query (:query/pill pills-api-params)})
        last-seen-article (:signal/last-seen-article signal)
        params (if last-seen-article
                 (assoc params :last-seen-article last-seen-article)
                 params)
        ;;boosting logic
        boosting-pills (-> (get db db-path-boost-query) :search-query :query/pills)
        boosting-pill (query/some-pills-query {:query/pills boosting-pills})
        params (if boosting-pill
                 (assoc params :query
                        {:pill/type "boost"
                         :pill/pills [(assoc (:query params) :pill/pills (concat [pills/lbracket]
                                                                                 (:pill/pills (:query params))
                                                                                 [pills/rbracket]))
                                      (assoc boosting-pill :pill/pills (concat [pills/lbracket]
                                                                               (:pill/pills boosting-pill)
                                                                               [pills/rbracket]))]})
                 params)]
    {:db (assoc-in db [db-path :clicked-article]
                   {:idx idx
                    :search-params params})
     :fx [[:dispatch detail-event]]})))

;; -- Subscriptions

(rf/reg-sub
  ::state
  (fn [db _]
    (db-path db)))

(rf/reg-sub
 ::articles-by-guids
 :<- [::state]
 (fn [state [_ guids]]
   (let [articles (:articles state)]
     (filter #(contains? guids (:guid %)) articles))))

(rf/reg-sub
  ::expanded-all?
  :<- [::state]
  (fn [{:keys [expanded articles]} _]
    (let [articles-ids (set (map :guid articles))
          expanded-ids (set expanded)]
      (empty? (difference articles-ids expanded-ids)))))


(rf/reg-sub
  ::selected-all?
  :<- [::state]
  (fn [{:keys [selected articles]} _]
    (let [articles-ids (set (map :guid articles))
          selected-ids (set selected)]
      (empty? (difference articles-ids selected-ids)))))

(rf/reg-sub
 ::show-boost-searchbar?
 :<- [::state]
 (fn [{:keys [show-boost-searchbar?]} _]
   show-boost-searchbar?))

(rf/reg-sub
 ::boost-query
 (fn [db _]
   (db-path-boost-query db)))

(rf/reg-sub
 ::senses
 :<- [::state]
 (fn [state]
   (:senses state)))

(rf/reg-sub
 ::free-text
 :<- [::state]
 (fn [state]
   (:free-text state)))